/**
 * Card chrome for the Concert status panel. One definition so the loan
 * documents, the supplemental documents and everything beside them read as the
 * same surface rather than three near-copies of it.
 */
export const concertSectionClass = `rounded-lg border border-bp-border bg-bp-elevated`

export const concertSecondaryButtonClass = `rounded-md border border-bp-border-strong bg-transparent px-3 py-1.5 text-[length:var(--step--2)] font-semibold text-bp-text hover:bg-bp-elevated-2 disabled:cursor-not-allowed disabled:opacity-50`

export const concertPrimaryButtonClass = `rounded-md bg-bp-accent px-4 py-2 text-[length:var(--step--1)] font-semibold text-bp-on-accent hover:bg-bp-accent-hover disabled:cursor-not-allowed disabled:opacity-50`

export function ConcertSection({
  title,
  testId,
  trailing,
  children,
}: {
  title: string
  testId: string
  trailing?: React.ReactNode
  children: React.ReactNode
}): JSX.Element {
  return (
    <section
      aria-label={title}
      data-testid={testId}
      className={concertSectionClass}
    >
      <div className="flex items-center justify-between gap-3 border-b border-bp-border px-4 py-3">
        <h3 className="text-[length:var(--step--1)] font-semibold text-bp-text">
          {title}
        </h3>
        {trailing}
      </div>
      {children}
    </section>
  )
}
